module["exports"] = [
  "###-###-####",
  "(###)-##-###-####",
  "+(###)-##-###-####",
  "+###-##-###-####",
  "1-###-###-####",
  "### ### ####"
];
